import { useMemo, useState } from "react";
import Icon from "../assets/icons/Icon";
import { Tab, Tabs } from "../shared/Components/UI/CustomTabs";
import tv_imag from "/assets/images/login_img.svg";
import { API_DASHBOARD_MARKET } from "../utils/api/ApiConstant";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getAxios } from "../shared/Services/commonService";
import DateUtils from "../utils/dateUtils";
import useMarketDetailsSocket from "../shared/Hooks/useMarketDetailsSocket";

/* eslint-disable react/prop-types */

const MinMaxInfo = ({ className = "minmax_box", min = "-", max = "-" }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={className}>
      <button
        type="button"
        className="minmax_toggle"
        onClick={() => setIsOpen((value) => !value)}
        aria-expanded={isOpen}
      >
        <Icon className="i_min_max" name="CircleAlert" size={16} />
      </button>
      <div className={`match-bet-box-min${isOpen ? " is-open" : ""}`}>
        <p>
          <span>Min: {min}</span>
          <span>Max: {max}</span>
        </p>
      </div>
    </div>
  );
};

const getMinLimit = (item) =>
  item?.minStack ?? item?.minBet ?? item?.min ?? item?.minOdds ?? "-";

const getMaxLimit = (item) =>
  item?.maxStack ?? item?.maxBet ?? item?.max ?? item?.maxOdds ?? "-";

const LiveCenterCard = ({
  className = "",
  title = "live center",
  isOpen = false,
  onToggle,
}) => {
  return (
    <div className={`matched-bet-card ${className}`.trim()}>
      <div className="tv-box-card">
        <div className="heading-name">
          <h2 className="mach_name">{title}</h2>
          <button
            type="button"
            className="tv-toggle"
            onClick={onToggle}
            aria-expanded={isOpen}
            aria-label={`Toggle ${title}`}
          >
            <Icon className="tv-icon" name="Tv" size={16} />
          </button>
        </div>
        <div className={`tv-box ${isOpen ? "show" : ""}`}>
          <img src={tv_imag} alt={title} />
        </div>
      </div>
    </div>
  );
};

const MatchDetails = () => {
  const [marketTab, setMarketTab] = useState("all");
  const [isTvBoxVisible, setIsTvBoxVisible] = useState(false);

  const { eventId } = useParams();

  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["marketData", eventId],
    queryFn: () => getAxios(`${API_DASHBOARD_MARKET}/${Number(eventId)}`),
    enabled: !!eventId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  const marketGroups = useMemo(() => {
    const grouped = {};

    data.forEach((item) => {
      const bettingType = item.bettingType;
      const marketId = item.marketId;

      const formattedDateTime = DateUtils.fromUTC(item.eventOpenOn);

      const [formattedDate, formattedTime] = formattedDateTime.split(",");

      if (!grouped[bettingType]) {
        grouped[bettingType] = {
          bettingType,
          markets: [],
        };
      }

      let existingMarket = grouped[bettingType].markets.find(
        (market) => String(market.marketId) === String(marketId),
      );

      if (!existingMarket) {
        existingMarket = {
          eventId: item.eventId,
          event_Id: item.event_Id,
          eventName: item.eventName,
          eventOpenOn: item.eventOpenOn,
          eventTypeId: item.eventTypeId,
          eventTypeName: item.eventTypeName,
          competitionName: item.competitionName,
          inPlay: item.inPlay,
          marketName: item.marketName,
          bettingType: item.bettingType,
          marketType: item.marketType,
          marketId: item.marketId,
          min: getMinLimit(item),
          max: getMaxLimit(item),

          formattedDate: formattedDate?.trim(),
          formattedTime: formattedTime?.trim(),

          runners: [],
        };

        grouped[bettingType].markets.push(existingMarket);
      }

      // add runners if exists
      if (item.runnerId) {
        const runnerExists = existingMarket.runners.some(
          (runner) => String(runner.runnerId) === String(item.runnerId),
        );

        if (!runnerExists) {
          existingMarket.runners.push({
            runnerId: item.runnerId,
            runnerName: item.runnerName,
          });
        }
      }
    });

    return Object.values(grouped);
  }, [data]);

  const allMarkets = marketGroups.flatMap((group) => group.markets);
  console.log("🚀 ~ MatchDetails ~ allMarkets:", allMarkets);

  const marketsWithRunners = allMarkets.filter(
    (market) => market.runners.length > 0,
  );

  const fancyMarkets = allMarkets.filter(
    (market) => market.runners.length === 0,
  );

  const marketIds = useMemo(
    () => [...new Set(data.map((item) => item.marketId).filter(Boolean))],
    [data],
  );
  const liveMarkets = useMarketDetailsSocket(marketIds);

  const liveRunnerMap = useMemo(() => {
    const map = {};

    Object.entries(liveMarkets).forEach(([marketId, market]) => {
      map[marketId] = Object.fromEntries(
        (market.runners || []).map((runner) => [String(runner.id), runner]),
      );
    });

    return map;
  }, [liveMarkets]);

  console.log("liveRunnerMap", liveRunnerMap);

  const renderFancyMarketCard = (market) => {
    const liveMarket = liveMarkets[market.marketId];
    // console.log("liveFancyMarket", liveMarket);
    const liveRunner = liveMarket?.runners?.[0];
    const back = liveRunner?.back || [];
    const lay = liveRunner?.lay || [];

    return (
      <div key={market.marketId} className="match-team-name-price-card">
        <div
          className="min-bet-main cursor-pointer"
          data-bs-toggle="modal"
          data-bs-target="#match-bet-run "
        >
          <h3 className="match-team-font">{market.marketName}</h3>

          <MinMaxInfo
            className="minmax_box_yes_no"
            min={liveMarket?.minBet || market.min}
            max={liveMarket?.maxBet || market.max}
          />
        </div>
        <div
          className={`match-team-price ${
            liveMarket?.marketStatus !== "OPEN" ? "market_suspend" : ""
          }`}
        >
          <ul>
            <li className="line-market-width responsive-show-price">
              <div className="match-price-box match-back-medium">
                <p className="match-price-color1">{back[0]?.price || "-"}</p>
                <span>{back[0]?.size || "-"}</span>
              </div>
              <div className="match-price-box match-lay-medium">
                <p className="match-price-color1">{lay[0]?.price || "-"}</p>
                <span>{lay[0]?.size || "-"}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>{error?.message || "Something went wrong"}</div>;
  }

  return (
    <section className="market_detail">
      <div className="market-analysis-mani">
        <div className="market_card">
          {allMarkets.length > 0 && (
            <div className="match-heading-name">
              <h2 className="mach_name">
                <span className="live_icon">
                  {" "}
                  {allMarkets[0].inPlay ? "In Play" : ""}
                </span>{" "}
                {allMarkets[0].eventName} - {allMarkets[0].competitionName}
              </h2>
              <p>
                {allMarkets[0].formattedDate} <span>|</span>
                <span>{allMarkets[0].formattedTime}</span>
              </p>
            </div>
          )}
          <LiveCenterCard
            className="mobile-ui"
            title="live center"
            isOpen={isTvBoxVisible}
            onToggle={() => setIsTvBoxVisible((value) => !value)}
          />
          {marketsWithRunners.map((runner) => {
            const liveMarket = liveMarkets[runner.marketId];
            // console.log("runner", runner);
            // console.log("liveMarket", liveMarket);
            const liveRunners = liveMarket?.runners || [];
            return (
              <div key={runner.marketId} className="answer_mach">
                <div className="heading_events-title">
                  <h3 className="cricket-events-title">{runner.marketName}</h3>
                  <MinMaxInfo
                    min={liveMarket?.minBet || runner.min}
                    max={liveMarket?.maxBet || runner.max}
                  />
                </div>
                <div className="match-team-name-price-main back_and_lay-box">
                  <div className="match-team-name-box"></div>
                  <div className="match-team-price">
                    <ul>
                      <li className="responsive-show-mobile-a">
                        <div className="match-price-first"></div>
                        <div className="match-price-first"></div>
                      </li>
                      <li className="responsive-show-mobile-b">
                        <div className="match-price-first">
                          <div className="match-price-box match-back-medium">
                            <p className="match-price-color1">Back</p>
                          </div>
                        </div>
                        <div className="match-price-first">
                          <div className="match-price-box match-lay-medium">
                            <p className="match-price-color1">Lay</p>
                          </div>
                        </div>
                      </li>
                      <li className="responsive-show-mobile-c">
                        <div className="match-price-first"></div>
                        <div className="match-price-first pr-0"></div>
                      </li>
                    </ul>
                  </div>
                </div>
                {runner.runners.map((item) => {
                  const liveRunner =
                    liveRunnerMap[runner.marketId]?.[String(item.runnerId)];
                  const back = liveRunner?.back || [];
                  const lay = liveRunner?.lay || [];

                  return (
                    <div
                      key={item.runnerId}
                      className="match-team-name-price-main"
                    >
                      <div className="match-team-name-box">
                        <p className="m-0 p-0">
                          {item.runnerName}
                          <br />
                          {/* <span className="match-team-count font-color-danger">
                      {" "}
                      0
                    </span> */}
                        </p>
                      </div>

                      <div
                        className={`match-team-price ${!back[0]?.price && !lay[0]?.price ? "market_suspend" : ""}`}
                      >
                        <ul>
                          <li className="responsive-show-mobile-a">
                            <div className="match-price-first">
                              <div className="match-price-box match-back-lightest">
                                <p className="match-price-color1">
                                  {back[2]?.price || "-"}
                                </p>
                                <span>{back[2]?.size || "-"}</span>
                              </div>
                            </div>
                            <div className="match-price-first">
                              <div className="match-price-box match-back-light">
                                <p className="match-price-color1">
                                  {back[1]?.price || "-"}
                                </p>
                                <span>{back[1]?.size || "-"}</span>
                              </div>
                            </div>
                          </li>
                          <li className="responsive-show-mobile-b">
                            <div className="match-price-first">
                              <div className="match-price-box match-back-medium">
                                <p className="match-price-color1">
                                  {back[0]?.price || "-"}
                                </p>
                                <span>{back[0]?.size || "-"}</span>
                              </div>
                            </div>
                            <div className="match-price-first">
                              <div className="match-price-box match-lay-medium">
                                <p className="match-price-color1">
                                  {lay[0]?.price || "-"}
                                </p>
                                <span>{lay[0]?.size || "-"}</span>
                              </div>
                            </div>
                          </li>
                          <li className="responsive-show-mobile-c">
                            <div className="match-price-first">
                              <div className="match-price-box match-lay-light">
                                <p className="match-price-color1">
                                  {lay[1]?.price || "-"}
                                </p>
                                <span>{lay[1]?.size || "-"}</span>
                              </div>
                            </div>
                            <div className="match-price-first">
                              <div className="match-price-box match-lay-lightest">
                                <p className="match-price-color1">
                                  {lay[2]?.price || "-"}
                                </p>
                                <span>{lay[2]?.size || "-"}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                })}
                {/* <div className="match-team-name-price-main">
                <div className="match-team-name-box">
                  <p className="m-0 p-0">
                    Adelaide Strikers
                    <br />
                    <span className="match-team-count font-color-danger">
                      {" "}
                      0
                    </span>
                  </p>
                </div>
                <div className="match-team-price">
                  <ul>
                    <li className="responsive-show-mobile-a">
                      <div className="match-price-first">
                        <div className="match-price-box match-back-lightest">
                          <p className="match-price-color1">2.06</p>
                          <span>175006</span>
                        </div>
                      </div>
                      <div className="match-price-first">
                        <div className="match-price-box match-back-light">
                          <p className="match-price-color1">2.08</p>
                          <span>175006</span>
                        </div>
                      </div>
                    </li>
                    <li className="responsive-show-mobile-b">
                      <div className="match-price-first">
                        <div className="match-price-box match-back-medium">
                          <p className="match-price-color1">2.07</p>
                          <span>175006</span>
                        </div>
                      </div>
                      <div className="match-price-first">
                        <div className="match-price-box match-lay-medium">
                          <p className="match-price-color1">2.02</p>
                          <span>175006</span>
                        </div>
                      </div>
                    </li>
                    <li className="responsive-show-mobile-c">
                      <div className="match-price-first">
                        <div className="match-price-box match-lay-light">
                          <p className="match-price-color1">1.05</p>
                          <span>175006</span>
                        </div>
                      </div>
                      <div className="match-price-first pr-0">
                        <div className="match-price-box match-lay-lightest">
                          <p className="match-price-color1">1.07</p>
                          <span>175006</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div> */}

                {/* <div className="match-team-name-price-main match-massage-card">
                <p className="match-massage">
                  Gujarat Assembly Election Bet Started In Our Exchange..
                </p>
              </div> */}
              </div>
            );
          })}
          {/* <div className="answer_mach">
            <div className="heading_events-title">
              <h3 className="cricket-events-title">Bookmaker</h3>
              <MinMaxInfo />
            </div>
            <div className="match-team-name-price-main back_and_lay-box">
              <div className="match-team-name-box"></div>
              <div className="match-team-price">
                <ul>
                  <li className="responsive-show-mobile-a">
                    <div className="match-price-first"></div>
                    <div className="match-price-first"></div>
                  </li>
                  <li className="responsive-show-mobile-b">
                    <div className="match-price-first">
                      <div className="match-price-box match-back-medium">
                        <p className="match-price-color1">back</p>
                      </div>
                    </div>
                    <div className="match-price-first">
                      <div className="match-price-box match-lay-medium">
                        <p className="match-price-color1">Lay</p>
                      </div>
                    </div>
                  </li>
                  <li className="responsive-show-mobile-c">
                    <div className="match-price-first"></div>
                    <div className="match-price-first pr-0"></div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="match-team-name-price-main">
              <div className="match-team-name-box">
                <p className="m-0 p-0">
                  Adelaide Strikers
                  <br />
                  <span className="match-team-count font-color-danger"> 0</span>
                </p>
              </div>
              <div className="match-team-price">
                <ul>
                  <li className="responsive-show-mobile-a">
                    <div className="match-price-first">
                      <div className="match-price-box match-back-lightest">
                        <p className="match-price-color1">2.06</p>
                        <span>175006</span>
                      </div>
                    </div>
                    <div className="match-price-first">
                      <div className="match-price-box match-back-light">
                        <p className="match-price-color1">2.08</p>
                        <span>175006</span>
                      </div>
                    </div>
                  </li>
                  <li className="responsive-show-mobile-b">
                    <div className="match-price-first">
                      <div className="match-price-box match-back-medium">
                        <p className="match-price-color1">2.07</p>
                        <span>175006</span>
                      </div>
                    </div>
                    <div className="match-price-first">
                      <div className="match-price-box match-lay-medium">
                        <p className="match-price-color1">2.02</p>
                        <span>175006</span>
                      </div>
                    </div>
                  </li>
                  <li className="responsive-show-mobile-c">
                    <div className="match-price-first">
                      <div className="match-price-box match-lay-light">
                        <p className="match-price-color1">1.05</p>
                        <span>175006</span>
                      </div>
                    </div>
                    <div className="match-price-first pr-0">
                      <div className="match-price-box match-lay-lightest">
                        <p className="match-price-color1">1.07</p>
                        <span>175006</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="match-team-name-price-main">
              <div className="match-team-name-box">
                <p className="m-0 p-0">
                  Adelaide Strikers
                  <br />
                  <span className="match-team-count font-color-danger"> 0</span>
                </p>
              </div>
              <div className="match-team-price">
                <ul>
                  <li className="responsive-show-mobile-a">
                    <div className="match-price-first">
                      <div className="match-price-box match-back-lightest">
                        <p className="match-price-color1">2.06</p>
                        <span>175006</span>
                      </div>
                    </div>
                    <div className="match-price-first">
                      <div className="match-price-box match-back-light">
                        <p className="match-price-color1">2.08</p>
                        <span>175006</span>
                      </div>
                    </div>
                  </li>
                  <li className="responsive-show-mobile-b">
                    <div className="match-price-first">
                      <div className="match-price-box match-back-medium">
                        <p className="match-price-color1">2.07</p>
                        <span>175006</span>
                      </div>
                    </div>
                    <div className="match-price-first">
                      <div className="match-price-box match-lay-medium">
                        <p className="match-price-color1">2.02</p>
                        <span>175006</span>
                      </div>
                    </div>
                  </li>
                  <li className="responsive-show-mobile-c">
                    <div className="match-price-first">
                      <div className="match-price-box match-lay-light">
                        <p className="match-price-color1">1.05</p>
                        <span>175006</span>
                      </div>
                    </div>
                    <div className="match-price-first pr-0">
                      <div className="match-price-box match-lay-lightest">
                        <p className="match-price-color1">1.07</p>
                        <span>175006</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="match-team-name-price-main match-massage-card">
              <p className="match-massage">
                Gujarat Assembly Election Bet Started In Our Exchange..
              </p>
            </div>
          </div> */}{" "}
        </div>

        {fancyMarkets.length > 0 ? (
          <div className="mach-fancy-box">
            <Tabs
              id="match-details-market-tabs"
              activeKey={marketTab}
              onSelect={setMarketTab}
            >
              <Tab eventKey="all" title="ALL">
                <div className="heading_fancy-title">
                  <p>All</p>
                </div>
                <div className="match-odds-main-card">
                  <div className="yes-no-card match-team-name-price-card">
                    <div className="min-bet-main cursor-pointer"></div>
                    <div className="match-team-price">
                      <ul>
                        <li className="line-market-width responsive-show-price">
                          <div className="match-price-box responsive-show-yes-no">
                            <p className="back-lay-text">yes</p>
                          </div>
                          <div className="match-price-box responsive-show-yes-no">
                            <p className="back-lay-text">no</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {fancyMarkets.length > 0 ? (
                    fancyMarkets.map(renderFancyMarketCard)
                  ) : (
                    <div className="match-team-name-price-card">
                      <div className="min-bet-main cursor-pointer">
                        <h3 className="match-team-font">
                          No fancy markets available
                        </h3>
                      </div>
                    </div>
                  )}
                </div>
              </Tab>
              {marketGroups
                .filter((item) =>
                  item.markets.some((market) => market.runners.length === 0),
                )
                .map((item) => (
                  <Tab
                    key={item.bettingType}
                    eventKey={item.bettingType}
                    title={item.bettingType}
                  >
                    <div className="heading_fancy-title">
                      <p>{item.bettingType}</p>
                    </div>
                    <div className="match-odds-main-card">
                      <div className="yes-no-card match-team-name-price-card">
                        <div className="min-bet-main cursor-pointer"></div>
                        <div className="match-team-price">
                          <ul>
                            <li className="line-market-width responsive-show-price">
                              <div className="match-price-box responsive-show-yes-no">
                                <p className="back-lay-text">yes</p>
                              </div>
                              <div className="match-price-box responsive-show-yes-no">
                                <p className="back-lay-text">no</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {item.markets
                        .filter((market) => market.runners.length === 0)
                        .map(renderFancyMarketCard)}
                      {/* <div className="match-team-name-price-card">
                  <div
                    className="min-bet-main cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#match-bet-run "
                  >
                    <h3 className="match-team-font">
                      5ST INNINGS 6 OVER LINE
                      <br />
                      <strong className="font-color-success">565486</strong>
                    </h3>

                    <MinMaxInfo className="minmax_box_yes_no" />
                  </div>
                  <div className="match-team-price">
                    <ul>
                      <li className="line-market-width responsive-show-price">
                        <div className="match-price-box match-back-medium">
                          <p className="match-price-color1">25.5</p>
                          <span>175006</span>
                        </div>
                        <div className="match-price-box match-lay-medium">
                          <p className="match-price-color1">33.6</p>
                          <span>178086</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="match-team-name-price-card">
                  <div
                    className="min-bet-main cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#match-bet-run "
                  >
                    <h3 className="match-team-font">
                      5ST INNINGS 6 OVER LINE
                      <br />
                      <strong className="font-color-success">565486</strong>
                    </h3>

                    <MinMaxInfo className="minmax_box_yes_no" />
                  </div>
                  <div className="match-team-price">
                    <ul>
                      <li className="line-market-width responsive-show-price">
                        <div className="match-price-box match-back-medium">
                          <p className="match-price-color1">25.5</p>
                          <span>175006</span>
                        </div>
                        <div className="match-price-box match-lay-medium">
                          <p className="match-price-color1">33.6</p>
                          <span>178086</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div> */}
                      {/* <div className="match-team-name-price-card match-massage-card">
                      <p className="match-massage">
                        Gujarat Assembly Election Bet Started In Our Exchange..
                      </p>
                    </div> */}
                    </div>
                  </Tab>
                ))}
              <Tab eventKey="player" title="Player">
                <div className="heading_fancy-title">
                  <p>Player</p>
                </div>
              </Tab>
              <Tab eventKey="other" title="Other">
                <div className="heading_fancy-title">
                  <p>Other</p>
                </div>
              </Tab>
            </Tabs>
          </div>
        ) : null}
      </div>
      <LiveCenterCard
        className="desktop-ui"
        title="live center"
        isOpen={isTvBoxVisible}
        onToggle={() => setIsTvBoxVisible((value) => !value)}
      />
    </section>
  );
};

export default MatchDetails;
